import { NamedKeyPrefix } from '@make-software/cspr-design';

const HASH_PREFIXES = [
  NamedKeyPrefix.CONTRACT_PACKAGE,
  NamedKeyPrefix.ACCOUNT_HASH,
  NamedKeyPrefix.CONTRACT,
  NamedKeyPrefix.HASH,
];

export const getHashWithoutPrefix = (value: string) => {
  const prefix = HASH_PREFIXES.find((hashPrefix) =>
    value.startsWith(hashPrefix)
  );

  return prefix ? value.slice(prefix.length) : value;
};
